import React from 'react';
import { Box, Container, Typography, Card, alpha, useTheme } from '@mui/material';
import {
  Search as SearchIcon,
  Security as SecurityIcon,
  Bolt as BoltIcon,
  Recycling as RecyclingIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const HomeWhyKrillouSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const features = [
    {
      key: 'search',
      icon: SearchIcon,
      accent: theme.palette.primary.main,
    },
    {
      key: 'security',
      icon: SecurityIcon,
      accent: theme.palette.success.main,
    },
    {
      key: 'speed',
      icon: BoltIcon,
      accent: theme.palette.warning.main,
    },
    {
      key: 'eco',
      icon: RecyclingIcon,
      accent: '#0f766e',
    },
  ];

  return (
    <Box component="section" sx={{ py: { xs: 4, md: 5 }, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
          <Typography variant="h4" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
            {t('homepage.features.title')}
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 680, mx: 'auto' }}>
            {t('homepage.features.subtitle')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
            gap: 2,
          }}
        >
          {features.map(({ key, icon: Icon, accent }) => (
            <Card
              key={key}
              elevation={0}
              sx={{
                height: '100%',
                p: 2.25,
                borderRadius: 3,
                border: '1px solid #ececec',
                boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
                background: '#fff',
              }}
            >
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: alpha(accent, 0.14),
                    color: accent,
                    mb: 2,
                  }}
                >
                  <Icon sx={{ fontSize: 28 }} />
                </Box>

                <Typography variant="h6" component="h3" sx={{ fontWeight: 700, mb: 1 }}>
                  {t(`homepage.features.${key}.title`)}
                </Typography>
                <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                  {t(`homepage.features.${key}.description`)}
                </Typography>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HomeWhyKrillouSection;